export default __webpack_public_path__ + "static/media/drag-icon.c73d28f2.svg";